import { api } from '@/api/ApiGateway.js'
import { useAuthStore } from '@/stores/authStore.js'
import { echoes } from '@/composables/echo/useEchoes.js'

class DataSubmissionApi
{
	constructor()
	{
		this.params = []
	}

	updateDescription(dataSubmissionId, description, onSuccess, onError) {
		api.post(`data-submission/description/${dataSubmissionId}`, { 'description': description }).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error updating data submission description.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	upload(fileData, onSuccess, onError)
	{
		api.post('data-submission/upload', fileData).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error uploading data.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	delete(dataSubmissionId, reasonForDeletion, onSuccess, onError)
	{
		api.delete(`data-submission/delete/${dataSubmissionId}`, {
			reason: reasonForDeletion,
		}).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error deleting data.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	fileExists(fileName, organizationId, callback)
	{
		const requestData = {
			'file_name': fileName,
			'organization_id': organizationId,
		}
		api.get('data-submission/file-exists', requestData).then(response =>
		{
			if (response.hasError())
			{
				callback(false)
				return
			}

			callback(response?.response?.data?.exists ?? false)
		})
	}

	async download(dataSubmissions, tenantName, organizationName, onComplete, onError)
	{
		const authStore = useAuthStore()
		const headers = {}
		headers['Authorization'] = `Bearer ${authStore.rawJwt}`
		headers['x-client-user-id'] = authStore.getAuth?.user()?.id
		headers['x-jwt-version-code'] = authStore.getAuth?.user()?.jwt_version_code
		headers['X-Socket-ID'] = echoes.socketId();

		const dataSubmissionIds = dataSubmissions.map((dataSubmission) => dataSubmission.id)
		const dataSubmissionNames = dataSubmissions.map((dataSubmission) => dataSubmission.file_name)

		const response = await api.axiosInstance.get('/data-submission/download', {
				params: {
					'data_submission_ids': dataSubmissionIds,
					'tenant_name': tenantName,
					'organization_name': organizationName,
					'organization_id': authStore.activeOrganizationId,
				},
				responseType: 'blob',
				headers: headers
			})
			.catch(err => {
				console.error('Download error:', err);
				onError(err)
			});

		if (!response)
		{
			return;
		}

		const blobUrl = window.URL.createObjectURL(new Blob([response.data]))

		// Force the file to download (hopefully) rather than open in a new window
		const link = document.createElement('a')
		link.href = blobUrl

		if (dataSubmissionIds.length > 1) {
			link.setAttribute('download', 'dataSubmissions.zip')
		}
		else {
			link.setAttribute('download', dataSubmissionNames[0])
		}
		document.body.appendChild(link)
		link.click()
		link.remove()
		window.URL.revokeObjectURL(blobUrl)

		onComplete()
	}
}

export const dataSubmissionApi = new DataSubmissionApi()